<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
    <p>{{message}}</p>
    <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="ok()" [disabled]="form.invalid"><i class="bi bi-x-circle"></i> Yes, reject</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()"><i class="bi bi-x-circle"></i> No, cancel</button>
</div>